/* <pdp-reviews>: reveals hidden cards in steps; hides the button when everything is visible. */
if (!customElements.get('pdp-reviews')) {
  class PdpReviews extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.step = parseInt(this.dataset.step || '8', 10);
      this.more = this.querySelector('[data-more]');
      if (this.more) this.more.addEventListener('click', () => this.reveal(), { signal: this.ac.signal });
      this.sync();
      this.clamp();
    }
    disconnectedCallback() { this.ac.abort(); }
    clamp() {
      const lines = parseInt(this.dataset.clamp || '0', 10); if (!lines) return;
      const more = this.dataset.moreLabel || 'Read more', less = this.dataset.lessLabel || 'Read less';
      this.querySelectorAll('.pd-reviews__text').forEach((t) => {
        t.classList.add('is-clamped');
        if (t.scrollHeight <= t.clientHeight + 2) return;
        const b = document.createElement('button'); b.type = 'button'; b.className = 'pd-reviews__readmore'; b.textContent = more; b.setAttribute('aria-expanded', 'false');
        b.addEventListener('click', () => { const open = t.classList.toggle('is-clamped') === false; b.textContent = open ? less : more; b.setAttribute('aria-expanded', open ? 'true' : 'false'); }, { signal: this.ac.signal });
        t.after(b);
      });
    }
    hiddenCards() { return Array.from(this.querySelectorAll('[data-card][hidden]')); }
    reveal() {
      const next = this.hiddenCards().slice(0, this.step);
      next.forEach((c) => { c.hidden = false; });
      if (next[0]) next[0].querySelector('.pd-reviews__author')?.setAttribute('tabindex', '-1');
      this.sync();
    }
    sync() { if (this.more) this.more.hidden = this.hiddenCards().length === 0; }
  }
  customElements.define('pdp-reviews', PdpReviews);
}
